import { useState, useEffect } from 'react'

import { Outlet } from 'react-router-dom'

// Type Imports
import { getMode, getSystemMode } from '@core/utils/serverHelpers'

import type { Mode, SystemMode } from '@core/types'

// Layout Imports
import LayoutWrapper from '@layouts/LayoutWrapper'
import VerticalLayout from '@layouts/VerticalLayout'

// Component Imports
import Providers from '@components/Providers'
import Navigation from '@components/layout/vertical/Navigation'
import VerticalFooter from '@components/layout/vertical/Footer'
import AuthGuard from '@/hocs/AuthGuard'
import Navbar from '@components/layout/vertical/Navbar'
import { useMediaQuery } from '@mui/material'

// Util Imports

const DashboardLayout = () => {
  // States
  const [mode, setMode] = useState<Mode>('light')
  const [systemMode, setSystemMode] = useState<SystemMode>('light')
  const [isLoading, setIsLoading] = useState(true)
  const isBreakpointReached = useMediaQuery('(max-width: 1200px)')

  // Vars
  const direction = 'ltr'

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const modeValue = await getMode()
        const systemModeValue = await getSystemMode()

        setMode(modeValue)
        setSystemMode(systemModeValue)
      } catch (error) {
        console.error('Error loading settings:', error)
      } finally {
        setIsLoading(false)
      }
    }

    loadSettings()
  }, [])

  if (isLoading) {
    return <div>Loading...</div>
  }

  return (
    <Providers direction={direction}>
      <AuthGuard>
        <LayoutWrapper
          systemMode={systemMode}
          verticalLayout={
            <VerticalLayout
              navigation={<Navigation mode={mode} />}
              footer={<VerticalFooter />}
              navbar={isBreakpointReached ? <Navbar /> : null}
            >
              <Outlet />
            </VerticalLayout>
          }
        />

        {/* <ScrollToTop className='mui-fixed'>
          <Button variant='contained' className='is-10 bs-10 rounded-full p-0 min-is-0 flex items-center justify-center'>
            <i className='tabler-arrow-up' />
          </Button>
        </ScrollToTop> */}
      </AuthGuard>
    </Providers>
  )
}

export default DashboardLayout
